import { SECONDARY_PRODUCTION_HOST } from 'Lib/hosts'

// Per-domain tracking ids (Meta Pixel + Signals Gateway). To give a subdomain
// its own tracking, add a TRACKING_OVERRIDES entry (shallow-merged over
// DEFAULT_TRACKING); set a field to `[]` to collect nothing for it rather than
// inheriting the default.
export type TrackingIds = {
  metaPixelIds: string[]
  signalsGatewayIds: string[]
}

const DEFAULT_TRACKING: TrackingIds = {
  metaPixelIds: ['1794832324097079', '1786729385251738'],
  // First id is the primary: the SDK loads its events.js directly, additional
  // ids are chained via events-config.js (see Services/SignalsGateway.service.ts).
  signalsGatewayIds: ['2402056774949389045', '2666936180798138262']
}

const TRACKING_OVERRIDES: Record<string, Partial<TrackingIds>> = {
  [SECONDARY_PRODUCTION_HOST]: {
    metaPixelIds: ['3544040685743813'],
    // No my2 SGW id yet — empty so it collects nothing rather than mixing into
    // the my.bodyfast.app gateway.
    signalsGatewayIds: []
  }
}

export const getTrackingIds = (hostname: string = location.hostname): TrackingIds => ({
  ...DEFAULT_TRACKING,
  ...TRACKING_OVERRIDES[hostname]
})
